import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Alert, Button } from 'react-bootstrap';
import * as ProductActions from 'redux/modules/products';
import { translate } from 'react-i18next';

/**
 * Onglet "Test ascenseur" de la fiche produit.
 *
 * Démarre une session Remote TestLift (dev.mdp-sts) pour les ascenseurs
 * ASC-IP et affiche le test dans une iframe. Le token one-shot renvoyé par
 * dev.mdp-sts n'est utilisé qu'une seule fois par le navigateur ; le secret
 * inter-serveur ne quitte jamais le backend Node.js.
 */
@translate(['common'])
@connect(
	state => ({
		testLiftSessionLoading: state.products.testLiftSessionLoading,
		testLiftSessionError: state.products.testLiftSessionError,
		testLiftSessionResult: state.products.testLiftSession
	}),
	dispatch => bindActionCreators({ ...ProductActions }, dispatch)
)
export default class RemoteTestLift extends Component {

	constructor(props) {
		super(props);
		this.state = { sessionContext: null };
		this.handleLaunch = this.handleLaunch.bind(this);
	}

	getSessionContext(props = this.props) {
		const params = props.urlParams || {};
		return JSON.stringify([props.productID, params.cid || params.id || null]);
	}

	componentDidMount() {
		this.active = true;
		this.props.resetTestLiftSession();
	}

	componentDidUpdate(prevProps) {
		if (this.getSessionContext(prevProps) !== this.getSessionContext()) {
			this.pendingRequest = null;
			this.props.resetTestLiftSession();
			this.setState({ sessionContext: null });
		}
	}

	componentWillUnmount() {
		this.active = false;
		this.pendingRequest = null;
		this.props.resetTestLiftSession();
	}

	handleLaunch() {
		if (!this.active || this.pendingRequest) return;
		const request = {};
		this.pendingRequest = request;
		this.setState({ sessionContext: this.getSessionContext() });
		return this.props.testLiftSession(this.props.productID, this.props.urlParams)
			.catch(() => {})
			.then(() => {
				if (this.pendingRequest === request) this.pendingRequest = null;
			});
	}

	render() {
		const { t } = this.props;
		const launched = this.state.sessionContext === this.getSessionContext();
		const testLiftSessionLoading = launched && this.props.testLiftSessionLoading;
		const testLiftSessionError = launched && this.props.testLiftSessionError;
		const testLiftSessionResult = launched && this.props.testLiftSessionResult;

		if (testLiftSessionLoading) {
			return (
				<div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 300 }}>
					<div style={{ fontSize: 16, color: '#666' }}>
						<i className="fa fa-spinner fa-spin" /> &nbsp;{t('productForm.test_lift_loading')}
					</div>
				</div>
			);
		}

		if (testLiftSessionError) {
			return (
				<div style={{ padding: 20, textAlign: 'center' }}>
					<Alert bsStyle="danger">
						{t('productForm.test_lift_error')} : {testLiftSessionError.message || String(testLiftSessionError)}
					</Alert>
					<Button bsStyle="primary" onClick={this.handleLaunch}>{t('productForm.test_lift_retry')}</Button>
				</div>
			);
		}

		if (testLiftSessionResult && testLiftSessionResult.iframe_url) {
			return (
				<div style={{ width: '100%', height: 600, position: 'relative' }}>
					<iframe
						src={testLiftSessionResult.iframe_url}
						title={t('productForm.test_lift')}
						style={{ width: '100%', height: '100%', minHeight: 455, border: 'none', display: 'block' }}
						allow="clipboard-write; geolocation"
						sandbox="allow-same-origin allow-scripts allow-forms allow-popups"
					/>
				</div>
			);
		}

		return (
			<div style={{ padding: 20, textAlign: 'center' }}>
				<Button bsStyle="primary" onClick={this.handleLaunch}>
					<i className="fa fa-play" /> &nbsp;{t('productForm.test_lift_launch')}
				</Button>
			</div>
		);
	}
}
